"use strict";

import Page from "./Permits.jsx";

export const auth = true;
export const title = "i18n:permits.permits";
export const Component = Page;
